/**
 * Causes of death, as the mortality log stores them. One list for the
 * Mortality page and the Daily Report wizard, so the two cannot drift.
 */
export const MORTALITY_CAUSES = [
  { value: "disease", label: "Disease" },
  { value: "heat_stress", label: "Heat Stress" },
  { value: "predator", label: "Predator" },
  { value: "unknown", label: "Unknown" },
  { value: "other", label: "Other" },
] as const;

export function causeLabel(value?: string | null): string {
  return MORTALITY_CAUSES.find((c) => c.value === value)?.label ?? "";
}
